export class OrderFloorPlanError extends Error {
  constructor() {
    super('Critical error in floor plan');
  }
}
